// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"83d6a9f0","329":"ff26b419","489":"d4872c63","623":"4f6855a7","753":"f0e56dea","760":"794ad276","901":"d4872c63","933":"794ad276"}[chunkId] + ".chunk.css";
};